import { useEffect, useRef } from "react";
import { ScrollText, Layers, Users, CalendarRange } from "lucide-react";

const SERVICES = [
  {
    icon: ScrollText,
    title: "Birth Chart Reading",
    desc: "A full 75-minute decode of your entire natal chart — purpose, personality, career and the houses shaping your year.",
    price: "$149",
  },
  {
    icon: Layers,
    title: "Tarot Session",
    desc: "A focused 45-minute past-present-future spread for the one question sitting at the front of your mind right now.",
    price: "$89",
  },
  {
    icon: Users,
    title: "Compatibility Report",
    desc: "A synastry reading for two charts — where you align, where you clash, and how to work with both honestly.",
    price: "$129",
  },
  {
    icon: CalendarRange,
    title: "Yearly Forecast",
    desc: "Your personal transits mapped month by month for the next 12 months, with key dates for love, money and career.",
    price: "$199",
  },
];

export const Services = () => {
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    if (!window.gsap || !window.ScrollTrigger || !sectionRef.current) return;
    const gsapLib = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    gsapLib.registerPlugin(ScrollTrigger);

    gsapLib.fromTo(
      cardRefs.current,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        stagger: 0.12,
        scrollTrigger: { trigger: sectionRef.current, start: "top 78%" },
      }
    );
  }, []);

  return (
    <section id="services" ref={sectionRef} className="cosmic-section max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <p className="reveal cosmic-eyebrow text-sm mb-5">Readings &amp; Sessions</p>
        <h2 className="reveal font-display text-3xl sm:text-4xl lg:text-5xl">Choose Your Path</h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-7">
        {SERVICES.map(({ icon: Icon, title, desc, price }, i) => (
          <div
            key={title}
            ref={(el) => (cardRefs.current[i] = el)}
            data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
            className="glass-card p-7 flex flex-col"
          >
            <Icon size={26} className="text-[#E8C27A] mb-6" />
            <h3 className="font-display text-lg mb-3">{title}</h3>
            <p className="text-[#F3EEE4] text-base font-light leading-relaxed mb-6 flex-1">{desc}</p>
            <div className="flex items-center justify-between pt-5 border-t border-[#E8C27A]/15">
              <span className="font-display text-xl gold-text">{price}</span>
              <a
                data-testid={`service-book-button-${title.toLowerCase().replace(/\s+/g, "-")}`}
                href="#"
                className="text-sm text-[#A99BFF] hover:text-[#E8C27A] transition-colors"
              >
                Book →
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
